import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group'
import AuthService from "../../lib/AuthService";

class LeftMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            main_menu_class_o : 'ind-menu ',
            main_menu_class_v : 'ind-menu ',
            main_menu_class_g : 'ind-menu ',
            main_menu_class_p : 'ind-menu ',
            main_menu_class_u : 'ind-menu ',
            anchor_class_g : 'toggle-click ',
            anchor_class_a : 'toggle-click ',
            anchor_class_v : 'toggle-click ',
            gtoggler_class : 'toggle-opener-block',
            visible: false

        };

        this.handleSubMenu = this.handleSubMenu.bind(this);
        this.Auth = new AuthService();
    }

    componentDidMount() {

        if( this.props.pageName === 'MY_UPLOADS' || this.props.pageName === 'AUDIO' || this.props.pageName === 'VIDEO') {
            this.setState({ visible: true });
        }


        let main_menu_class_o = this.state.main_menu_class_o;
        let main_menu_class_v = this.state.main_menu_class_v;
        let main_menu_class_g = this.state.main_menu_class_g;
        let main_menu_class_p = this.state.main_menu_class_p;
        let main_menu_class_u = this.state.main_menu_class_u;
        let anchor_class_g = this.state.anchor_class_g;
        let anchor_class_a = this.state.anchor_class_a;
        let anchor_class_v = this.state.anchor_class_v;

        let gtoggler_class = this.state.gtoggler_class;

        if(this.props.pageName === 'OVERVIEW'){
            main_menu_class_o += ' active';
        }
        else if(this.props.pageName === 'VIGNETS' || this.props.pageName === 'VIGDETAIL'){
            main_menu_class_v += ' active';
        }
        else if(this.props.pageName === 'MY_UPLOADS'){
            anchor_class_g += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if( this.props.pageName === 'AUDIO'){
            anchor_class_a += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if( this.props.pageName === 'VIDEO') {
            anchor_class_v += ' active';
            main_menu_class_g += ' active';
            gtoggler_class += ' show';
        }else if(this.props.pageName === 'PLAYLIST'  || this.props.pageName === 'PLAYLISTDETAIL'){
            main_menu_class_p += ' active';
        }
        else if(this.props.pageName === 'USER'){
            main_menu_class_u += ' active';
        }





        this.setState({main_menu_class_o : main_menu_class_o, main_menu_class_v : main_menu_class_v, main_menu_class_g : main_menu_class_g, main_menu_class_p : main_menu_class_p, main_menu_class_u : main_menu_class_u, anchor_class_g : anchor_class_g,anchor_class_a : anchor_class_a,anchor_class_v : anchor_class_v, gtoggler_class : gtoggler_class });


    }

    handleSubMenu(e, url) {
        e.stopPropagation();
        this.setState({ visible: ! this.state.visible });

        /*let menu_item = document.getElementsByClassName('ind-menu1');

        if( menu_item[0].classList.contains("active")) {
            menu_item[0].classList.remove("active");
        }
        else {
            menu_item[0].classList.add("active")
        }*/

        if(url) {
            window.location = url;
        }
    }

    openCatView() {
        window.open("https://agency.vignets.com/vignetsv2/category/index.html", "_blank")
    }

    render() {
        return (

            <div className="side-content-area">
                <ul className="side-menu-list">
                    <li className= {this.state.main_menu_class_o}>
                        <a href="/overview" className="menu-block">
                            <span className="icon-lib overview-ico"></span>
                            <span className="menu-text">Overview</span>
                        </a>
                    </li>
                    <li className= {this.state.main_menu_class_v}>
                        <a href="/vignets" className="menu-block">
                            <span className="icon-lib manage-ico"></span>
                            <span className="menu-text">Nuggets</span>
                        </a>
                    </li>
                    <li className="ind-menu1">
                        <a href="javascript:;" className="menu-block" data-rel="/gallery" onClick={(e)=>this.handleSubMenu(e, '/gallery')}>
                            <span className="icon-lib resource-ico"></span>
                            <span className="menu-text">Gallery</span>
                        </a>
                        <CSSTransitionGroup transitionName="gallery-cont">
                            { this.state.visible ? <div className={this.state.gtoggler_class}>
                                <ul className="toggle-opener">
                                    <li className="ind-gallerymenu">
                                        <a href="/gallery" className={`${this.state.anchor_class_g} graphic-ico`}><span
                                            className="menu-text">Graphics</span></a>
                                    </li>
                                    <li className="ind-gallerymenu">
                                        <a href="/audio" className={`${this.state.anchor_class_a} audio-ico `}><span
                                            className="menu-text">Audio</span></a>
                                    </li>
                                    <li className="ind-gallerymenu">
                                        <a href="/video" className={`${this.state.anchor_class_v} video-ico`}><span
                                            className="menu-text">Video</span></a>
                                    </li>
                                </ul>
                            </div> : null }
                        </CSSTransitionGroup>

                    </li>
                    <li className= {this.state.main_menu_class_p}>
                        <a href="/playlists" className="menu-block">
                            <span className="icon-lib ply-ico"></span>
                            <span className="menu-text ply-menu-text">Playlist</span>
                        </a>
                    </li>
                    {this.Auth.getProfile().user_id === 'u5003ffa658949' &&
                    <li className={this.state.main_menu_class_u}>
                        <a href="/users" className="menu-block">
                            <span className="icon-lib admin-ico"></span>
                            <span className="menu-text">User</span>
                        </a>
                    </li>
                    }

                    {/*<li className= {this.state.main_menu_class_u}>*/}
                    {/*    <a href="javascript:;" onClick={this.openCatView} className="menu-block">*/}
                    {/*        <span className="icon-lib resource-ico"></span>*/}
                    {/*        <span className="menu-text">Category</span>*/}
                    {/*    </a>*/}
                    {/*</li>*/}

                </ul>
            </div>

        );
    }
}

LeftMenu.propTypes = {
    pageName: PropTypes.string
}

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/components/common/LeftMenu.js